<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" @click.self="fechar">
    <div class="rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto" style="background-color: var(--bg-secondary)">
      <!-- Header -->
      <div class="sticky top-0 z-10 px-6 py-4 border-b" style="background-color: var(--bg-secondary); border-color: var(--border)">
        <h2 class="text-2xl font-bold" style="color: var(--text-primary)">
          {{ cliente ? `✏️ ${t('financeiro.modalCliente.editTitle')}` : `➕ ${t('financeiro.modalCliente.newTitle')}` }}
        </h2>
      </div>

      <!-- Body -->
      <div class="p-6 space-y-6">
        <!-- Dados Básicos -->
        <div class="space-y-4">
          <h3 class="text-lg font-semibold" style="color: var(--text-primary)">👤 {{ t('financeiro.modalCliente.basicData') }}</h3>
          
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label class="block text-sm font-medium mb-1" style="color: var(--text-secondary)">{{ t('financeiro.modalCliente.name') }} *</label>
              <input v-model="form.nome" type="text" required class="input-field w-full" />
            </div>
            <div>
              <label class="block text-sm font-medium mb-1" style="color: var(--text-secondary)">{{ t('financeiro.modalCliente.cpfCnpj') }}</label>
              <input v-model="form.cpfCnpj" type="text" class="input-field w-full" />
            </div>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label class="block text-sm font-medium mb-1" style="color: var(--text-secondary)">{{ t('common.email') }}</label>
              <input v-model="form.email" type="email" class="input-field w-full" />
            </div>
            <div>
              <label class="block text-sm font-medium mb-1" style="color: var(--text-secondary)">{{ t('financeiro.modalCliente.phone') }}</label>
              <input v-model="form.telefone" type="text" class="input-field w-full" />
            </div>
          </div>

          <div>
            <label class="block text-sm font-medium mb-1" style="color: var(--text-secondary)">{{ t('financeiro.modalCliente.mobile') }}</label>
            <input v-model="form.celular" type="text" class="input-field w-full" />
          </div>
        </div>

        <!-- Endereço -->
        <div class="space-y-4">
          <h3 class="text-lg font-semibold" style="color: var(--text-primary)">📍 {{ t('financeiro.modalCliente.address') }}</h3>
          
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <label class="block text-sm font-medium mb-1" style="color: var(--text-secondary)">{{ t('financeiro.modalCliente.zipCode') }}</label>
              <input v-model="form.cep" type="text" class="input-field w-full" @blur="buscarCep" />
            </div>
            <div class="md:col-span-2">
              <label class="block text-sm font-medium mb-1" style="color: var(--text-secondary)">{{ t('financeiro.modalCliente.street') }}</label>
              <input v-model="form.logradouro" type="text" class="input-field w-full" />
            </div>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div>
              <label class="block text-sm font-medium mb-1" style="color: var(--text-secondary)">{{ t('financeiro.modalCliente.number') }}</label>
              <input v-model="form.numero" type="text" class="input-field w-full" />
            </div>
            <div>
              <label class="block text-sm font-medium mb-1" style="color: var(--text-secondary)">{{ t('financeiro.modalCliente.complement') }}</label>
              <input v-model="form.complemento" type="text" class="input-field w-full" />
            </div>
            <div>
              <label class="block text-sm font-medium mb-1" style="color: var(--text-secondary)">{{ t('financeiro.modalCliente.neighborhood') }}</label>
              <input v-model="form.bairro" type="text" class="input-field w-full" />
            </div>
            <div>
              <label class="block text-sm font-medium mb-1" style="color: var(--text-secondary)">{{ t('financeiro.modalCliente.city') }}</label>
              <input v-model="form.cidade" type="text" class="input-field w-full" />
            </div>
          </div>

          <div>
            <label class="block text-sm font-medium mb-1" style="color: var(--text-secondary)">{{ t('financeiro.modalCliente.state') }}</label>
            <input v-model="form.estado" type="text" maxlength="2" class="input-field w-full" />
          </div>
        </div>

        <!-- Empresa (Opcional) -->
        <div class="space-y-4">
          <h3 class="text-lg font-semibold" style="color: var(--text-primary)">🏢 {{ t('financeiro.modalCliente.companyOptional') }}</h3>
          
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label class="block text-sm font-medium mb-1" style="color: var(--text-secondary)">{{ t('financeiro.modalCliente.companyName') }}</label>
              <input v-model="form.nomeEmpresa" type="text" class="input-field w-full" />
            </div>
            <div>
              <label class="block text-sm font-medium mb-1" style="color: var(--text-secondary)">{{ t('financeiro.modalCliente.companyCnpj') }}</label>
              <input v-model="form.cnpjEmpresa" type="text" class="input-field w-full" />
            </div>
          </div>
        </div>

        <!-- Observações -->
        <div>
          <label class="block text-sm font-medium mb-1" style="color: var(--text-secondary)">📝 {{ t('financeiro.modalCliente.notes') }}</label>
          <textarea v-model="form.observacoes" rows="3" class="input-field w-full"></textarea>
        </div>
      </div>

      <!-- Footer -->
      <div class="sticky bottom-0 px-6 py-4 border-t flex justify-end gap-3" style="background-color: var(--bg-secondary); border-color: var(--border)">
        <button @click="fechar" class="btn-secondary">{{ t('common.cancel') }}</button>
        <button @click="salvar" class="btn-primary">{{ cliente ? t('common.update') : t('common.create') }}</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import Swal from 'sweetalert2'

const { t } = useI18n()

const props = defineProps({
  cliente: Object
})

const emit = defineEmits(['fechar', 'salvar'])

const form = ref({
  nome: '',
  cpfCnpj: '',
  email: '',
  telefone: '',
  celular: '',
  cep: '',
  logradouro: '',
  numero: '',
  complemento: '',
  bairro: '',
  cidade: '',
  estado: '',
  nomeEmpresa: '',
  cnpjEmpresa: '',
  observacoes: '',
  ativo: true
})

onMounted(() => {
  if (props.cliente) {
    form.value = { ...props.cliente }
  }
})

function fechar() {
  emit('fechar')
}

function salvar() {
  if (!form.value.nome) {
    Swal.fire('Atenção', t('financeiro.modalCliente.nameRequired'), 'warning')
    return
  }
  emit('salvar', form.value)
}

async function buscarCep() {
  if (!form.value.cep || form.value.cep.replace(/\D/g, '').length < 8) return
  
  try {
    const cep = form.value.cep.replace(/\D/g, '')
    const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`)
    const data = await response.json()
    
    if (!data.erro) {
      form.value.logradouro = data.logradouro
      form.value.bairro = data.bairro
      form.value.cidade = data.localidade
      form.value.estado = data.uf
    }
  } catch (error) {
    console.error('Erro ao buscar CEP:', error)
  }
}
</script>

<style scoped>
.input-field {
  @apply px-3 py-2 rounded-lg border;
  background-color: var(--bg-primary);
  color: var(--text-primary);
  border-color: var(--border);
}

.btn-primary {
  @apply px-6 py-2 rounded-lg font-medium transition-all bg-blue-600 text-white hover:bg-blue-700;
}

.btn-secondary {
  @apply px-6 py-2 rounded-lg font-medium transition-all;
  background-color: var(--bg-primary);
  color: var(--text-primary);
  border: 1px solid var(--border);
}

.btn-secondary:hover {
  background-color: var(--bg-secondary);
}
</style>
